"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _checkIcon = _interopRequireDefault(require("./checkIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function WBMSelectionCard(props) {
  var onClick = function onClick(e) {
    e.preventDefault();

    if (props.onClick) {
      props.onClick(props.selectedId);
    }
  };

  var radioButtonClass = "";
  var cardClass = "row mx-0 align-items-center selection-card";

  if (props.selected) {
    radioButtonClass += "active";
    cardClass += " selected";
  }

  var onKeyDown = function onKeyDown(e) {
    if (e.key === "Enter") {
      onClick(e);
    }
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    onClick: onClick,
    className: cardClass,
    id: props.id,
    tabIndex: 0,
    onKeyDown: onKeyDown
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-9"
  }, props.children), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-3 text-right my-auto h-100"
  }, /*#__PURE__*/_react["default"].createElement(_checkIcon["default"], {
    className: "check-icon " + radioButtonClass
  }))), props.subDisplay && /*#__PURE__*/_react["default"].createElement("div", {
    className: "row subDisplay"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col"
  }, /*#__PURE__*/_react["default"].createElement("hr", null), props.subDisplay))));
}

WBMSelectionCard.propTypes = {
  onClick: _propTypes["default"].func.isRequired,
  selected: _propTypes["default"].bool.isRequired,
  selectedId: _propTypes["default"].string.isRequired,
  subDisplay: _propTypes["default"].element
};
var _default = WBMSelectionCard;
exports["default"] = _default;
//# sourceMappingURL=wbmSelectionCard.js.map